import { AmplitudeEvent } from "@/telemetry/AmplitudeEvent";

export class TeamMemberRemovedEvent extends AmplitudeEvent {
	constructor( teamName, removedEmail ) {
		super();
		this.name = "Team Member Removed";
		this.eventProperties.team_name = teamName;
		this.eventProperties.removed_email = removedEmail;
	}
}



// WEBPACK FOOTER //
// ./src/telemetry/TeamMemberRemovedEvent.js